/* eslint-disable react/no-array-index-key -- Array is not dynamic therefore we dont need this rule */
import { styled, Skeleton, Typography } from '@ori-ui/mui';
import type { FC, HTMLAttributes } from 'react';

const UnifiedSkeleton = styled(Skeleton)({
  transform: 'none',
});

const LinkLabelSkeleton = styled(UnifiedSkeleton)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(2),
  fontSize: theme.typography.fontSize,
}));

const LinkColumnRoot = styled('div')(({ theme }) => ({
  width: '120px',
}));

const ListLink = styled(UnifiedSkeleton)({
  height: '18px',
  marginTop: '18px',
  '&:first-of-type': {
    marginTop: '35px',
  },
});

export interface LinkColumnProps extends HTMLAttributes<HTMLDivElement> {
  customSkeletons?: Array<{
    /** Represents a percentage of a width of final skeleton */
    skeletonWidth: number;
  }>;
}

export const MobileLinkColumn = styled(UnifiedSkeleton)({
  width: '100%',
  height: '50px',
});

export const LinkColumn: FC<LinkColumnProps> = ({ customSkeletons, children, ...rest }) => (
  <LinkColumnRoot {...rest}>
    <Typography variant="h6">
      <LinkLabelSkeleton width={85} />
    </Typography>
    {customSkeletons ? (
      customSkeletons.map(({ skeletonWidth }, index) => (
        <ListLink
          key={index}
          width={`${skeletonWidth}%`}
        />
      ))
    ) : (
      <>
        <ListLink width="80%" />
        <ListLink width="100%" />
        <ListLink width="30%" />
        <ListLink width="90%" />
        <ListLink width="45%" />
      </>
    )}
    {children}
  </LinkColumnRoot>
);
